export const CheckLanguageMoment = (id) => {
  switch (id) {
    case "th":
      return "th";
    case "en":
      return "en";
    case "zh":
      return "zh-cn";
    case "ms":
      return "ms-my";
    case "hi":
      return "hi";
    case "lo":
      return "lo";
    case "id":
      return "id";
    case "vi":
      return "vi";
    case "fil":
      return "tl-ph";
    case "ja":
      return "ja";
    case "ko":
      return "kr";
    default:
      return "en";
  }
};
//
